var app_rate_card_table = $('#app-rate-card-table');
var app_rate_card_table_archived = $('#app-rate-card-table-archived');

if (app_rate_card_table.length) {
    var data_table_order = [ 0, "desc" ];
    var url;
    var queryString = window.location.search;
    var searchParams = new URLSearchParams(queryString);
    var market_id = searchParams.get('market_id');
    //console.log(market_id);
    if (market_id) {
        url = '/rate_cards?market_id=' + market_id;
    } else {
        url = '/rate_cards';
    }
    function initializeRateCardsTable() {
        if (market_id) {
            url = '/rate_cards?market_id=' + market_id;
        } else {
            url = '/rate_cards';
        }
        var has_order = 0
        $('#app-rate-card-table').DataTable({
            "processing": true,
            "serverSide": true,
            ajax: {
                url: url,
                dataSrc: 'data',
            },
            order: data_table_order,
            columns: [
                {data: 'id'},//0
                {data: 'name'},//1
                {data: 'type'},//2
                {data: 'market_name'},//3
                {data: 'vendor_name'},//4
                {data: 'created_at_string'},//5
                {data: 'id'},//6
            ],
            destroy: true,
            pageLength: user_entries,
            "columnDefs": [
                {
                    "targets": 0,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = ' <div class="checkbox checkbox-danger rate_cards_check"> <input class="checkbox" class="form-control" type="checkbox"  id="' + cellData + '" name="selected_rate_cards[]" value="' + cellData + '" ><label for="' + cellData + '"> </label></div>';
                        $(td).html(html);
                    }
                },
                {
                    "targets": 1,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '<a href="/rate_cards/worksheet/' + rowData.worksheet_id  + '" data-id="' + cellData + '">' + '<i class="fa fa-link"></i> ' + cellData + '</a>';
                        $(td).html(html);
                    }
                },
                {
                    "targets": 6,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        // console.log('rowData', rowData);
                        // var html = '';
                        // html += '<div class="btn-group" role="group">';
                        // html += '<div  class="btn-group" role="group"><a  href="/rate_cards/edit/' + cellData + '" role="button" class="btn btn-success btn-sm btn-outline" title="Edit Rate Card">' +
                        //     '<i class="fa fa-pencil"></i> Edit ' +
                        //     '</a></div>';
                        //
                        // html += '<div style="" class="btn-group " role="group"><a  href="javascript:void(0)" data-id="' + cellData + '"  role="button" class="btn btn-danger btn-sm delete-rate-card btn-outline" title="Delete Campaign">' +
                        //     '<i class="fa fa-trash-o"></i> Delete ' +
                        //     '</a></div>';
                        // console.log('rowData_rowData', rowData)
                        //
                        // if(rowData.worksheet_id !== 0) {
                        //     html += '<div style="" class="btn-group " role="group"><a  href="/rate_cards/worksheet/' + rowData.worksheet_id  + '" data-id="' + cellData + '"  role="button" class="btn btn-info btn-sm btn-outline" title="Go to Worksheet">' +
                        //         '<i class="ti-back-left"></i> Go to WS' +
                        //         '</a></div>';
                        // }
                        //
                        // // html += '<ul class="dropdown-menu">' +
                        // //     '<li><a style="background-color: white; color: dimgray; font-size: 13px" row-id="' + row + '" data-id="' + rowData.id + '" class="proposal_report" href="#"> Send</a></li>' +
                        // //     '<li><a style="background-color: white; color: dimgray; font-size: 13px" data-id="' + rowData.id + '" class="proposal_details" href="#">  Details</a></li>';
                        // html += '</div>';

                        var html = '<div class="btn-group">\n' +
                            '            <button type="button" class="btn btn-outline btn-success waves-effect waves-light m-r-5 btn-off" data-toggle="dropdown">\n' +
                            '                <i class="fa fa-ellipsis-v"></i>\n' +
                            '                <span class="sr-only">Toggle Dropdown</span>\n' +
                            '            </button>\n' +
                            '            <ul class="dropdown-menu dropdown-menu-right">\n' +
                            '                <li class="ms-hover">' + '<a href="/rate_cards/edit/' + cellData + '" >' + '<i class="fa fa-pencil"></i> Edit' + '</a>' + '</li>\n' +
                            '                <li class="ms-hover">' + '<a href="/rate_cards/worksheet/' + rowData.worksheet_id  + '" data-id="' + cellData + '">' + '<i class="ti-back-left"></i> Go to WS' + '</a>' + '</li>\n' +
                            '                <li class="ms-hover">' + '<a class="delete-rate-card" href="javascript:void(0)" data-id="' + cellData + '" >' + '<i class="fa fa-trash-o"></i> Delete' + '</a>' + '</li>\n' +
                            '                <li role="separator" class="divider ms-hover"></li>\n' +
                            '                <li class="ms-hover"><a href="javascript::;"></a></li>\n'
                        '            </ul>\n' +
                        '        </div>';

                        $(td).html(html);
                    }
                }
            ]
        });
    }

    $('#app-rate-card-table').on( 'length.dt', function ( e, settings, len ) {
        user_entries = len;
    });
    $('#app-rate-card-table').on( 'order.dt', function ( e, settings, len) {
        data_table_order = [len[0].col, "" + len[0].dir + ""];
    } );
    $('#app-rate-card-table').on('click', '.delete-rate-card', function (){
        var id = $(this).attr('data-id');
        swal({
                title: "Warning!",
                text: "Are you sure to delete this Rate Card?",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "OK",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if(isConfirm === true){
                    show_loader();
                    $.ajax({
                        type: 'GET',
                        url: '/rate_cards/delete/' + id,
                        dataType: 'json',
                        encode: true,
                        success: function (data) {
                            global_notification('success', "Rate Card Deleted...");
                            initializeRateCardsTable();
                            hide_loader();
                        },
                        error: function (xhr) {
                            ajax_error();
                            debug(xhr.responseText);
                            hide_loader();
                        }
                    });
                }

            });
    });

    initializeRateCardsTable();

    //Archive feature
    $('#select_all_rate_cards').on('click', function (e) {
        $('#app-rate-card-table input:checkbox').prop('checked', true);
    });
    $('#deselect_all_rate_cards').on('click', function (e) {
        $('#app-rate-card-table input:checkbox').prop('checked', false);
    });

    $('#archive_rate_cards').on('click', function (){
        var selectedItems = [];
        $('.rate_cards_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        var text = selectedItems.length > 0 ? 'This Rate Card will be archived. Are yo sure to continue?' : 'Please select at least one Rate Card first.';
        $('#generalWarningModalDiv').html(text);
        $('#ok_got_it').hide();
        $('#archive_rate_card_confirm').hide();
        $('#activate_rate_card_confirm').hide();
        if(selectedItems.length > 0)
            $('#archive_rate_card_confirm').show();
        else
            $('#ok_got_it').show();
        $('#generalWarningModal').modal('show');
    });

    $('#archive_rate_card_confirm').on('click', function (){
        show_overlay_loader($('#generalWarningModal .modal-content'));
        var selectedItems = [];
        $('.rate_cards_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        var params = {
            rate_cards: selectedItems,
        };
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: '/rate_cards/archive',
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                hide_overlay_loader($('#generalWarningModal .modal-content'));
                window.location.reload();
            },
            error: function (xhr) {
                hide_overlay_loader($('#generalWarningModal .modal-content'));
                ajax_error();
                debug(xhr.responseText);

            }
        });

    });

    // $('#select_all_adv_archived').on('click', function (e) {
    //     $('#app-advertisers-table-archived input:checkbox').prop('checked', true);
    // });
    // $('#deselect_all_adv_archived').on('click', function (e) {
    //     $('#app-advertisers-table-archived input:checkbox').prop('checked', false);
    // });

    $('#show_archived_rate_cards_table').on('click', () => {
        $('#rate_cards').removeClass('content-current');
        $('#archived_rate_cards').addClass('content-current');
    });
    $('#show_rate_cards_table').on('click', () => {
        $('#archived_rate_cards').removeClass('content-current');
        $('#rate_cards').addClass('content-current');
    });
    $('#create_rate_cards_modal').on('click', () => {
        $('#createRateCardModal').modal('show');
    })
    const showParam = new URLSearchParams(window.location.search).get('show');
    if (typeof showParam !== 'undefined' && showParam !== null && showParam === 'create') {
        $('#createRateCardModal').modal('show');
    } else if(typeof showParam !== 'undefined' && showParam !== null && showParam === 'bump_rates') {
        $('#BumpRatesRulesModal').modal('show');
    }

    $('#show_popup_ratings_settings').on('click', () => {
        $('#app-rate-cards-form #worksheet').removeClass('content-current');
        $('#app-rate-cards-form #ratings').addClass('content-current');
        $('#show_popup_ratings_settings').hide();
        $('#show_popup_worksheet_settings').show();
    });
    $('#show_popup_worksheet_settings').on('click', () => {
        $('#app-rate-cards-form #ratings').removeClass('content-current');
        $('#app-rate-cards-form #worksheet').addClass('content-current');
        $('#show_popup_worksheet_settings').hide();
        $('#show_popup_ratings_settings').show();
    });

}

if (app_rate_card_table_archived.length) {
    var data_table_order = [ 0, "desc" ];
    var url;
    var queryString = window.location.search;
    var searchParams = new URLSearchParams(queryString);
    var market_id = searchParams.get('market_id');
    //console.log(market_id);
    if (market_id) {
        url = '/rate_cards/archived?market_id=' + market_id;
    } else {
        url = '/rate_cards/archived';
    }
    function initializeRateCardsArchivedTable() {
        var has_order = 0
        $('#app-rate-card-table-archived').DataTable({
            "processing": true,
            "serverSide": true,
            ajax: {
                url: url,
                dataSrc: 'data',
            },
            order: data_table_order,
            columns: [
                {data: 'id'},//0
                {data: 'name'},//1
                {data: 'market_name'},//2
                {data: 'vendor_name'},//3
                {data: 'created_at_string'},//4
                {data: 'archived_at_string'},//5
                {data: 'archived_by_name'},//6
            ],
            destroy: true,
            pageLength: user_entries,
            "columnDefs": [
                {
                    "targets": 0,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = ' <div class="checkbox checkbox-danger rate_cards_archived_check"> <input class="checkbox" class="form-control" type="checkbox"  id="' + cellData + '" name="selected_rate_cards[]" value="' + cellData + '" ><label for="' + cellData + '"> </label></div>';
                        $(td).html(html);
                    }
                },
                // {
                //     "targets": 6,
                //     "orderable": false,
                //     "createdCell": function (td, cellData, rowData, row, col) {
                //         console.log('rowData', rowData);
                //         var html = '';
                //         html += '<div class="btn-group" role="group">';
                //         html += '<div  class="btn-group" role="group"><a  href="/rate_cards/edit/' + cellData + '" role="button" class="btn btn-success btn-sm btn-outline" title="Edit Rate Card">' +
                //             '<i class="fa fa-pencil"></i> Edit ' +
                //             '</a></div>';
                //
                //         html += '<div style="" class="btn-group " role="group"><a  href="javascript:void(0)" data-id="' + cellData + '"  role="button" class="btn btn-danger btn-sm delete-rate-card btn-outline" title="Delete Campaign">' +
                //             '<i class="fa fa-trash-o"></i> Delete ' +
                //             '</a></div>';
                //         console.log('rowData_rowData', rowData)
                //
                //         if(rowData.worksheet_id !== 0) {
                //             html += '<div style="" class="btn-group " role="group"><a  href="/rate_cards/worksheet/' + rowData.worksheet_id  + '" data-id="' + cellData + '"  role="button" class="btn btn-info btn-sm btn-outline" title="Go to Worksheet">' +
                //                 '<i class="ti-back-left"></i> Go to WS' +
                //                 '</a></div>';
                //         }
                //
                //         // html += '<ul class="dropdown-menu">' +
                //         //     '<li><a style="background-color: white; color: dimgray; font-size: 13px" row-id="' + row + '" data-id="' + rowData.id + '" class="proposal_report" href="#"> Send</a></li>' +
                //         //     '<li><a style="background-color: white; color: dimgray; font-size: 13px" data-id="' + rowData.id + '" class="proposal_details" href="#">  Details</a></li>';
                //         html += '</div>';
                //
                //         $(td).html(html);
                //     }
                // }
            ]
        });
    }

    $('#app-rate-card-table-archived').on( 'length.dt', function ( e, settings, len ) {
        user_entries = len;
    });
    $('#app-rate-card-table-archived').on( 'order.dt', function ( e, settings, len) {
        data_table_order = [len[0].col, "" + len[0].dir + ""];
    } );

    initializeRateCardsArchivedTable();

    //Archive feature
    $('#select_all_rate_cards_archived').on('click', function (e) {
        $('#app-rate-card-table-archived input:checkbox').prop('checked', true);
    });
    $('#deselect_all_rate_cards_archived').on('click', function (e) {
        $('#app-rate-card-table-archived input:checkbox').prop('checked', false);
    });

    $('#activate_rate_cards').on('click', function (){
        var selectedItems = [];
        $('.rate_cards_archived_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        var text = selectedItems.length > 0 ? 'This Rate Card will be activated. Are yo sure to continue?' : 'Please select at least one Rate Card first.';
        $('#generalWarningModalDiv').html(text);
        $('#ok_got_it').hide();
        $('#archive_rate_card_confirm').hide();
        $('#activate_rate_card_confirm').hide();
        if(selectedItems.length > 0)
            $('#activate_rate_card_confirm').show();
        else
            $('#ok_got_it').show();
        $('#generalWarningModal').modal('show');
    });

    $('#activate_rate_card_confirm').on('click', function (){
        show_overlay_loader($('#generalWarningModal .modal-content'));
        var selectedItems = [];
        $('.rate_cards_archived_check input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        var params = {
            rate_cards: selectedItems,
        };
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: '/rate_cards/activate',
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                hide_overlay_loader($('#generalWarningModal .modal-content'));
                window.location.reload();
            },
            error: function (xhr) {
                hide_overlay_loader($('#generalWarningModal .modal-content'));
                ajax_error();
                debug(xhr.responseText);
            }
        });

    });

    /**
     * Bump Rates Rules
     **/

    $('#bump_rates_rules_button').on('click', function (){
        get_BumpRatesRules();
    });
    function get_BumpRatesRules() {
        show_loader();
        $.ajax({
            type: "GET",
            url: "/get/agency/rate_card/bump_rates_rules/0",
            dataType: 'json',
            success: function (data) {
                if (typeof data[0] !== 'undefined') {
                    var html = '';
                    var selected_op = false;
                    $('#bump_rules_percent option').each(function () {
                        var sel = parseInt($(this).val()) === parseInt(data[0][0].percent) ? 'selected' : '';
                        selected_op = parseInt($(this).val()) === parseInt(data[0][0].percent) ? true : selected_op;
                        html += '<option value="' + $(this).val() + '" ' + sel + '>' + $(this).html() + '</option>';
                    });
                    if (selected_op === true)
                        $('#bump_rules_percent').html(html);

                    var html = '';
                    var selected_op = false;
                    $('#bump_rules_percent1 option').each(function () {
                        var sel = parseInt($(this).val()) === parseInt(data[1][0].percent) ? 'selected' : '';
                        selected_op = parseInt($(this).val()) === parseInt(data[1][0].percent) ? true : selected_op;
                        html += '<option value="' + $(this).val() + '" ' + sel + '>' + $(this).html() + '</option>';
                    });
                    if (selected_op === true)
                        $('#bump_rules_percent1').html(html);

                    var html = '';
                    var selected_op = false;
                    var rule_3_index = '';
                    for(var index in data){
                        if(parseInt(index) !== 0 && parseInt(index) !== 1)
                            rule_3_index = index;
                    }
                    $('#bump_rules_percent2 option').each(function () {
                        var sel = parseInt($(this).val()) === parseInt(data[rule_3_index][0].percent) ? 'selected' : '';
                        selected_op = parseInt($(this).val()) === parseInt(data[rule_3_index][0].percent) ? true : selected_op;
                        html += '<option value="' + $(this).val() + '" ' + sel + '>' + $(this).html() + '</option>';
                    });
                    if (selected_op === true) {
                        $('#bump_rules_percent2').html(html);
                        var html = '';
                        $('#bump_rules_number2 option').each(function () {
                            if(!isNaN(parseInt(rule_3_index)))
                              var sel = parseInt($(this).val()) === parseInt(rule_3_index) ? 'selected' : '';
                            else
                              var sel = $(this).val() === rule_3_index ? 'selected' : '';
                            html += '<option value="' + $(this).val() + '" ' + sel + '>' + $(this).html() + '</option>';
                        });
                        $('#bump_rules_number2').html(html);
                    }
                }
                hide_loader();
                $('#BumpRatesRulesModal').modal('show');
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
                hide_loader();
            }
        });
    }
    $('#create_update_bump_rates_rules').on('click', function (){
        show_overlay_loader('#BumpRatesRulesModal');
        var params_new = {
            rule_0 : $('#bump_rules_percent option:selected').val(),
            rule_1 : $('#bump_rules_percent1 option:selected').val(),
            rule_3 : $('#bump_rules_percent2 option:selected').val(),
            weeks_after : $('#bump_rules_number2 option:selected').val(),
            automatically: $("input:checkbox[name=bump_rules_apply]:checked").attr('value'),
        }
        $.ajax({
            type: 'POST',
            url: '/agency/rules_bump_rates/create_or_update',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params_new),
            dataType: "json",
            contentType: "application/json",
            dataType: 'json',
            encode: true,
            success: function (data) {
                global_notification('success', 'Bump Rates Rules has been created.');
                hide_overlay_loader('#BumpRatesRulesModal');
                $('#BumpRatesRulesModal').modal('hide');
            },
            error: function (xhr) {
                global_notification('error', 'An error has happened please contact GaleForceMedia Support.');
                hide_overlay_loader('#BumpRatesRulesModal');
                debug(xhr.responseText);
            }
        });
    });

}